import mongoose from "mongoose";

export type MongoObjectId = mongoose.Types.ObjectId;

/** Coerce a lean/document _id (or string) to ObjectId for TS-safe assignments. */
export function asObjectId(value: unknown): MongoObjectId {
  if (value instanceof mongoose.Types.ObjectId) {
    return value;
  }
  if (typeof value === "string" && mongoose.Types.ObjectId.isValid(value)) {
    return new mongoose.Types.ObjectId(value);
  }
  return value as MongoObjectId;
}

/** Coerce _id-like values to string for comparisons and logging. */
export function objectIdToString(value: unknown): string {
  if (value instanceof mongoose.Types.ObjectId) {
    return value.toString();
  }
  if (typeof value === "string") {
    return value;
  }
  if (
    value &&
    typeof value === "object" &&
    "toString" in value &&
    typeof (value as { toString: unknown }).toString === "function"
  ) {
    return (value as { toString(): string }).toString();
  }
  return String(value);
}
